import { render } from "./App.vue?vue&type=template&id=5d332bb8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5d332bb8&lang=css"

import exportComponent from "/home/chris/Documents/HELSINKI/Uni_IFT/truscanWebapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__